module.exports = "/_next/static/images/4b4916b377ab5c5c942d30b204dd55dc-nuconta-inclined-device@3x.png";